import topContributorsBarView from './topContributorsBarComponent.html';
import './topContributorsBarComponent.css';

export function topContributorsBarComponent() {
	return {
		bindings: {},
		controllerAs: 'vm',
		controller: topContributorsBarComponentCtrl,
		template: topContributorsBarView,
	};
}

export class topContributorsBarComponentCtrl {
	constructor(Api, modal) {
		'ngInject';
		this.modal = modal;
		// we want 4 so we can display up to 3 and know if we need to indicate there is more
		Api.get('/users/top_contributors', { limit: 4 }).then(users => (this.users = users));
	}

	showDetails() {
		this.modal.state('hub.loggedin.TopContributorStandings', {
			heading: 'Top Contributors - Last 30 Days',
			width: 620,
			height: 'full',
		});
	}
}
